import { colombia } from "./data";
export { colombia } from "./data";
// ── Regex validators ───────────────────────────────────────────────────────
export const DEPARTMENT_CODE_PATTERN = /^\d{2}$/;
export const MUNICIPALITY_CODE_PATTERN = /^\d{5}$/;
export function isValidDepartmentCodeFormat(code) {
    return DEPARTMENT_CODE_PATTERN.test(code);
}
export function isValidMunicipalityCodeFormat(code) {
    return MUNICIPALITY_CODE_PATTERN.test(code);
}
// ── Lookups (O(1) after first call) ────────────────────────────────────────
const deptByCode = new Map();
const muniByCode = new Map();
for (const dept of colombia.departments) {
    deptByCode.set(dept.code, dept);
    for (const muni of dept.municipalities) {
        muniByCode.set(muni.code, { department: dept, municipality: muni });
    }
}
export function getDepartment(code) {
    return deptByCode.get(code) ?? null;
}
export function getDepartmentName(code) {
    return getDepartment(code)?.name ?? null;
}
export function getMunicipality(code) {
    return muniByCode.get(code) ?? null;
}
export function getMunicipalityName(code) {
    return getMunicipality(code)?.municipality.name ?? null;
}
/**
 * Validates a municipality code belongs to the given department code.
 * Also validates that the municipality exists in the dataset.
 */
export function isMunicipalityInDepartment(municipalityCode, departmentCode) {
    const hit = muniByCode.get(municipalityCode);
    return !!hit && hit.department.code === departmentCode;
}
/**
 * All departments (sorted by name already in the JSON).
 */
export function listDepartments() {
    return colombia.departments.map((d) => ({ code: d.code, name: d.name }));
}
/**
 * Municipalities for a department. Returns [] if the department code is unknown.
 */
export function listMunicipalities(departmentCode) {
    return deptByCode.get(departmentCode)?.municipalities ?? [];
}
//# sourceMappingURL=index.js.map